import React, { useContext, useEffect, useState } from 'react'
import { CertificateOutletType } from '..'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { GlobalTable, HeaderLine, LoadMoreButton, Td, TdButtons, Th, Tr } from '../../../../components/styles/table-style'
import axios from 'axios'
import { ParamType } from '../CreateParam'
import editPen from '../../../../assets/certificates/Tables/pencil.svg'

const ParamTable = () => {
  const [ parameters, setParameters ] = useState<ParamType[]>([])
  const { setTabIndex } = useOutletContext<CertificateOutletType>()
  const navigate = useNavigate()
  
  useEffect(() => {
    setTabIndex(1)
  }, [])
  
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_CERTIFICATES_BASE_URL}/param`)
      .then(response => {
        if(response.data) setParameters(response.data)
      })
      .catch(error => {
        console.error(error)
      })
  }, [])
  
  return (
    <>
      <GlobalTable>
        <thead>
          <HeaderLine>
            <Th>Nome do parâmetro</Th>
            <Th>Classe</Th>
            <Th>Família</Th>
            <Th>ASTM</Th>
            <Th>UNS</Th>
            <Th>DIN</Th>
            <Th>AISI</Th>
            <Th>Outros</Th>
            <Th></Th>
          </HeaderLine>
        </thead>
        <tbody>
          {parameters.map((param, index) => 
            <Tr key={index}>
              <Td>{param.name}</Td>
              <Td>{param.class}</Td>
              <Td>{param.family}</Td>
              <Td>{param.astm}</Td>
              <Td>{param.uns}</Td>
              <Td>{param.din}</Td>
              <Td>{param.aisi}</Td>
              <Td>{param.others}</Td>
              <TdButtons>
                <img src={editPen} alt='edit-icon' onClick={() => navigate(`edit/?id=${param.id}`)} />
              </TdButtons>
            </Tr>
          )}
        </tbody>
      </GlobalTable>
    </>
  )
}

export default ParamTable